export default {"src":"/_next/static/image/src/assets/icons/filter-icons/ac.efc1b41b8df243eb0b6226728b3974f7.svg","height":40,"width":40};